import './product-sets.scss';
import {node_observable_component} from 'common/util/ComponentDecorator';
import ModalUtil from 'common/util/ModalUtil';
import {ProductSetsCart} from './product-sets-cart';
import modalUtil from 'common/util/ModalUtil';
import galleryService from 'common/util/galleryService';

@node_observable_component
export class ProductSetsList {
    static classname = 'product-sets__list';
    #cart = null;

    constructor($productSetsList) {
        this.$productSetsList = $productSetsList;
        this.#cart = new ProductSetsCart($productSetsList.find('.product-sets-cart'));
        const initActiveItems = [];
        $productSetsList.find('.product-sets-item').each((ind, item) => {
            const $item = $(item);
            $item.find('.checkbox__input').prop('checked', true);
            const $link = $item.find('.product-sets-item__name');
            initActiveItems.push({sku_id: $item.attr('data-sku-id'), settings: JSON.parse($item.attr('data-settings')),
            url: $link.attr('href'), name:$link.text()});
        });
        this.#cart.initActiveItems(initActiveItems);
        this.initEventListeners()
    }

    initEventListeners() {
        this.$productSetsList.find('.product-sets-item__change-product').on('click', (e) => {
            const $link = $(e.currentTarget);
            const $checkbox = $link.closest('.product-sets-item').find('.checkbox__input');

            if (!$checkbox.is(':checked')) {
                return;
            }

            const allItems = JSON.parse($link.attr('data-all-items'));
            const currentSkuId = $link.attr('data-current-sku-id');
            const $modalContent = $(this.$productSetsList.closest('.product-sets').find('#product-sets-modal__content').prop('content').cloneNode(true).firstChild)
            const $modalSlider = $modalContent.find('.js-slider');
            const modalSliderExist = $modalSlider.length;
            const isMobileAndSlider = window.innerWidth < 900 && modalSliderExist;
            const isDesktopAndList = window.innerWidth > 900 && !modalSliderExist;

            if (isMobileAndSlider) {
                $modalSlider.replaceWith($('<div class="product-sets-modal__content product-sets-modal__content_mobile"></div>'));
            } else if (isDesktopAndList) {
                $modalContent.find('.product-sets-modal__content').replaceWith(
                    '<div class="js-slider" data-js-slides-per-view="5" data-js-slides-per-view-mobile="2">' +
                    '<div class="swiper-container">' +
                    '<div class="swiper-wrapper product-sets-modal__content">' +
                    '</div>' +
                    '</div>' +
                    '</div>')
            }


            allItems.forEach((itemData) => {
                if (itemData.sku_id === currentSkuId) {
                    return;
                }

                const $modalItem = $(this.$productSetsList.closest('.product-sets').find('#product-sets-modal__item').prop('content').cloneNode(true).firstChild);
                $modalItem.find('.product-sets-modal__item-img').attr('src', itemData.image);
                $modalItem.find('.product-sets-modal__item-name').text(itemData.name).attr('href', itemData.frontend_url);
                $modalItem.find('.product-sets-modal__item-price').text(itemData.price);

                if (itemData.compare_price !== 0) {
                    $modalItem.find('.product-sets-modal__item-compare-price').text(itemData.compare_price);
                }

                $modalItem.on('click', '.product-sets-modal__item-btn', (e) => this.modalItemClick($(e.currentTarget), $modalContent, $link, itemData));

                if (isMobileAndSlider) {
                    $modalItem.removeClass('swiper-slide').addClass('product-sets-modal__wrap-item');
                } else if (isDesktopAndList) {
                    $modalItem.removeClass('product-sets-modal__wrap-item').addClass('swiper-slide');
                }

                $modalContent.find('.product-sets-modal__content_mobile').on('touchmove', (e) => e.stopPropagation());
                $modalContent.find('.product-sets-modal__content').append($modalItem);
            });

            ModalUtil.openContent($modalContent);
        })

        this.$productSetsList.on('change', '.product-sets__item', (e) => {
            const $item = $(e.currentTarget);
            const $checkbox = $(e.target);
            const itemPrice = parseFloat($item.attr('data-price'));
            const itemComparePrice = parseFloat($item.attr('data-compare-price'));
            const skuId = $item.attr('data-sku-id')

            if ($checkbox.is(':checked')) {
                this.#cart.price += itemPrice
                this.#cart.comparePrice += itemComparePrice;
                const $linkName = $item.find('.product-sets-item__name');
                this.#cart.activeItemsPush({sku_id: skuId, settings: JSON.parse($item.attr('data-settings')),
                url: $linkName.attr('href'), name: $linkName.text()});
            } else {
                this.#cart.price -= itemPrice;
                this.#cart.comparePrice -= itemComparePrice;
                this.#cart.activeItemsRemove(skuId);
            }

            this.#cart.saving = this.#cart.comparePrice - this.#cart.price;
            $item.toggleClass('product-sets-item_disabled');
        });

        galleryService.onListOpen('.product-sets-item', '.product-sets__list', '.product-sets-item__img', 'data-zoom');
    }

    modalItemClick($btn, $modalContent, $link, itemData) {
        setTimeout(()=>{
            modalUtil.close();
        },200);

        $modalContent.find('.product-sets-modal__item-btn').removeClass('product-sets-modal__item-btn_selected');
        $btn.addClass('product-sets-modal__item-btn_selected');

        const $product = $link.closest('.product-sets-item');
        this.#cart.activeItemsRemove($product.attr('data-sku-id'));
        this.#cart.activeItemsPush({sku_id: itemData.sku_id, settings: itemData.settings, url: itemData.frontend_url, name:itemData.name});
        const $img = $product.find('.product-sets-item__img');
        const srcSet = `${itemData.image} 1x, ${itemData.image.replace(/\.(?=[^.]*$)/, '@2x.')} 2x`;

        $img.attr('src', itemData.image);
        $img.attr('data-src', itemData.image);
        $img.attr('data-srcset', srcSet);
        $img.attr('srcset', srcSet);
        $img.attr('name', itemData.name);

        $product.find('.product-sets-item__name').text(itemData.name).attr('href', itemData.frontend_url);
        $product.find('.product-sets-item__price').text(itemData.price);

        if (itemData.compare_price !== 0) {
            $product.find('.product-sets-item__compare-price').show().text(itemData.compare_price);
        } else {
            $product.find('.product-sets-item__compare-price').hide().text('')
        }

        $product.attr('data-id', itemData.id);
        $product.attr('data-sku-id', itemData.sku_id);
        $product.attr('data-settings', JSON.stringify(itemData.settings));

        this.#cart.price += (parseFloat(itemData.clear_price) - parseFloat($product.attr('data-price')));
        this.#cart.comparePrice += (parseFloat(itemData.clear_compare_price) - parseFloat($product.attr('data-compare-price')));
        this.#cart.saving = this.#cart.comparePrice - this.#cart.price;

        $product.attr('data-price', itemData.clear_price);
        $product.attr('data-compare-price', itemData.clear_compare_price);

        $link.attr('data-current-sku-id', itemData.sku_id);
    }
}